import React from "react";
import Table from "../../components/common/table/Table";
import ExcelExport from "../../components/common/ui/Export/ExcelExport.jsx";
import generateXlsx from "../../components/common/export/generateXlsx";
import Button from "../../components/common/ui/Button.jsx";
import PDFExport from "../../components/common/ui/Export/PDFExport.jsx";
import { useDispatch, useSelector } from "react-redux";
import { revenueReportingActions } from "../../_store/revenueReport.slice.js";

const RevenueReportTable = ({
  title,
  columns,
  data,
  totalRowCount,
  pagination,
  paginationPerPage,
  onChangePage,
  onChangeRowsPerPage,
  currentPage,
  handleClickExcel,
  handleClickPDF,
  setCurrentShowingTable,
  setTableShow,
  setReports,
  handleSearch,
  handleSort,
  sortingColumn,
  sortingDirection
}) => {

  const { reports } = useSelector((state) => state.revenueReporting);
  const dispatch = useDispatch();

  const handleBack = () => {
    setTableShow(false);
    setCurrentShowingTable("");
    setReports((prevState) => ({
      ...prevState,
      inmateResidentID: 0,
      rowCountPerPage: 10,
      pageNo: 1,
      firstName: "",
      firstNameValue: 0,
      lastName: "",
      lastNameValue: 0,
      taskNo: 0,
      refundTaskNo: 0,
      sortBy: ""
    }));
    dispatch(
      revenueReportingActions.setReports({
        ...reports,
        inmateResidentID: 0,
        rowCountPerPage: 10,
        pageNo: 1,
        firstName: "",
        firstNameValue: 0,
        lastName: "",
        lastNameValue: 0,
        taskNo: 0,
        refundTaskNo: 0,
        sortBy: ""
      })
    );
    handleSearch();
  };

  return (
    <div className="card shadow-sm b-r-all   p-4 border border-dark-grey mt-3 w-100 mb-4">
      <div className="d-flex flex-wrap justify-content-between align-items-center">
        <div className="w-100">
          <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap resp-space">
            <h3 className="form_title_uppercase text-color mb-0">
              {title} LIST
            </h3>
            <div className="d-flex flex-wrap gap-3 align-items-center">
              {title === "CACTAS CREDITS" && (
                <PDFExport
                  handlePDFExport={handleClickPDF}
                  className="btn btn-primary me-2"
                />
              )}
              {data?.length > 0 && (
                <ExcelExport
                  variant="soft-gray"
                  handleExcelExport={handleClickExcel}
                />
              )}
              <Button
                label="Back"
                type="button"
                //className="btn btn-danger"
                onClick={handleBack}
                variant="danger"
                icon={"fa-solid fa-angle-left"}
                status={"primary"}
                disabled={false}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="p-3">
        <Table
          //title={title}
          columns={columns}
          data={data}
          totalRowCount={totalRowCount}
          pagination={pagination}
          paginationPerPage={paginationPerPage}
          onChangePage={onChangePage}
          onChangeRowsPerPage={onChangeRowsPerPage}
          currentPage={currentPage}
          onSort={handleSort}
          serverSideSort
          sortColumn={sortingColumn}
          sortDirection={sortingDirection}
        />
      </div>
    </div>
  );
};

export default React.memo(RevenueReportTable);
